import { ComponentQueryLoader } from "../../../../../shared/component-query-loader";
import { useQuery } from "@apollo/client";
import { CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1Document } from "../../../../../../generated";
import { AdhocTransaction, Submission, Transactions } from "../../../../../shared/transactions/transactions";

export interface TransactionsContainerProps {
    caseId: string;
    isCaseOrApplicant: string;
}

export const TransactionsContainer: React.FC<TransactionsContainerProps> = (props) => {
  const { data, loading, error } = useQuery(CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1Document, {
    variables: { credentialVerificationCaseV1Id: props.caseId },
  });

  return (
    <ComponentQueryLoader
      loading={loading}
      error={error}
      hasData={data?.credentialVerificationCaseV1}
      hasDataComponent={
        <Transactions 
          data={{
            caseId: props.caseId,
            transactions: {
              submission: data?.credentialVerificationCaseV1?.financeDetails?.transactions?.submission as Submission,
              adhocTransactions: data?.credentialVerificationCaseV1?.financeDetails?.transactions?.adhocTransactions as AdhocTransaction[]
            }
          }} 
          isCaseOrApplicant={props?.isCaseOrApplicant}
          submissionReason="Intealth Requested for Credential Verification"
        />
      }
    />
  );
};
